import { useSelector } from "react-redux";
import thumbnail from "../../../../assets/images/thumbnail.png";
import getSymbolFromCurrency from "currency-symbol-map";

const Product = ({ value: product, currency }) => {
  const { order_details: i18n } = useSelector((state) => state.i18n);
  return (
    <div className="omg-list-item">
      <div className="omg-list-item__image">
        <img src={product.image ?? thumbnail} alt="Product" />
      </div>
      <div className="omg-list-item__content">
        <span className="omg-list-item__title">{product?.name}</span>
        <span className="omg-list-item__text">{product?.variant_title}</span>
        <span className="omg-list-item__text">
          {product.quantity}{" "}
          {product?.quantity > 1 ? i18n.item_plural : i18n.item_singular} - {""}
          {getSymbolFromCurrency(currency)}
          {product?.price}
        </span>
      </div>
    </div>
  );
};

export default Product;
